<div>
	<app-company-add
		label="Add a law firm"
		[name]="name"
		[firm]="lawFirm"
		(onSubmit)="onSubmit($event)"
	></app-company-add>
</div>
